module.exports = __webpack_public_path__ + "static/media/vi.c60f0454.svg";